<template>
  <div class="menu-wrapper">
    <div class="logo">
      <img :src="imgLogo" alt="LOGO" class="logo-img" />
    </div>
    <div class="nav-hamburger">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
    </div>
    <el-menu :default-openeds="[routes[0].code]">
      <template v-for="app in routes">
        <el-submenu :index="app.code" :key="app.code">
          <template slot="title">
            <i :class="`icon${app.code}`" class="iconfont" />
            <span v-if="app.name">{{ app.name }}</span>
          </template>
          <template v-for="item in app.children">
            <template v-if="!item.hidden">
              <router-link
                v-if="
                  !item.hidden && item.children && item.children.length === 1
                "
                :to="item.path + '/' + item.children[0].path"
                :key="item.children[0].name"
              >
                <el-menu-item
                  :index="
                    item.path +
                      '/' +
                      (item.children[0].redirect || item.children[0].path)
                  "
                  class="submenu-title-noDropdown"
                >
                  <span
                    v-if="item.children[0].meta && item.children[0].meta.title"
                    >{{ item.children[0].meta.title }}</span
                  >
                </el-menu-item>
              </router-link>

              <el-submenu
                v-if="!item.hidden && item.children && item.children.length > 1"
                :index="item.redirect || item.path || item.name"
                :key="item.name"
              >
                <template slot="title">
                  <span
                    v-if="item.meta && item.meta.title"
                    style="display: inline-block"
                    >{{ item.meta.title }}</span
                  >
                </template>
                <template v-if="!child.hidden" v-for="child in item.children">
                  <sidebar-item
                    class="nest-menu"
                    v-if="child.children && child.children.length > 0"
                    :routes="[child]"
                    :key="child.path"
                  ></sidebar-item>
                  <router-link
                    v-else
                    :to="item.path + '/' + child.path"
                    :key="child.name"
                  >
                    <el-menu-item
                      :index="item.path + '/' + (child.redirect || child.path)"
                    >
                      <span v-if="child.meta && child.meta.title">{{
                        child.meta.title
                      }}</span>
                    </el-menu-item>
                  </router-link>
                </template>
              </el-submenu>
            </template>
            <!-- <template v-else-if="!item.hidden">
              <el-menu-item
                v-if="!item.child || item.child.length === 0"
                :key="item.pageId"
                :index="item.pageId"
                class="submenu-title-noDropdown"
              >
                <a
                  :href="item.href" class="link-name"
                >
                  <i
                    v-if="item.icon"
                    :class="`icon${item.icon}`"
                    class="iconfont"
                  />
                  <span v-if="item.name">{{
                    item.name
                  }}</span>
                </a>
              </el-menu-item>

              <el-submenu
                v-if="item.child && item.child.length > 0"
                :index="item.pageId + app.code"
                :key="item.pageId + app.code"
              >
                <template slot="title">
                  <i
                    v-if="item.icon"
                    :class="`icon${item.icon}`"
                    class="iconfont"
                  />
                  <span v-if="item.name">{{ item.name }}</span>
                </template>

                <template v-for="child in item.child">
                  <sidebar-item
                    class="nest-menu"
                    v-if="!child.hidden && child.child && child.child.length > 0"
                    :routes="[child]"
                    :key="child.path"
                  ></sidebar-item>

                  <a
                    v-else-if="!child.hidden"
                    :href="child.href"
                    :key="child.pageId"
                  >
                    <el-menu-item
                      :index="child.pageId"
                      :key="child.pageId"
                    >
                      <i
                        v-if="child.icon"
                        :class="`icon${child.icon}`"
                        class="iconfont"
                      />
                      <span v-if="child.name">{{
                        child.name
                      }}</span>
                    </el-menu-item>
                  </a>
                </template>
              </el-submenu>
            </template> -->
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import imgLogo from "@/assets/logo_images/chery_logo.png";
import { mapState, mapGetters } from "vuex";
import Hamburger from "@/components/Hamburger";
export default {
  name: "SidebarItem",
  data() {
    return {
      imgLogo
    };
  },
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar"]),
    ...mapState({
      role: state =>
        state.user.currentCategory === "09" ? "user" : "userDealer"
    })
  },
  props: {
    routes: {
      type: Array
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
      console.log("routes", this.routes);
    }
  }
};
</script>
<style lang="scss" scoped>
.menu-wrapper {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .link-name {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  .nav-hamburger {
    text-align: center;
    padding: 10px;
  }
  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    transition: all 0.2s;
    background-color: #252525;
    // padding: 0 22px;
    img {
      display: inline-block;
      width: 100px;
      height: 64px;
    }
  }
  a {
    color: #fff;
  }
  .iconfont {
    width: 16px;
    height: 17px;
  }
  ::v-deep {
    .el-menu {
      background-color: #363636 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue